import { useEffect, useState } from "react"
import { Button, Col, Container, Form, FormCheck, Row, Tab, Tabs } from "react-bootstrap"
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from "zod"
import { ServicosService } from "../../../services/api/Servicos/ServicosService"

import { useNavigate, useParams } from "react-router-dom"
import { float2moeda, limpaTelefone, moeda2float } from "../../../utils/Funcoes"
import { useHookFormMask } from 'use-mask-input';
import { NumericFormat } from 'react-number-format'
import { tiposServicosUtils } from "../../../utils/tiposServicosUtils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Loading from "../../../components/Loader/Loading"
import ConfiguracoesSistemaPrincipal from "../ConfiguracoesSistemaPrincipal"
import { usePermissoes } from "../../../hooks/usePermissoes"
import PermissoesComponent from "../../../components/PermissaoComponent"
import ServicosProfissionais from "./ServicosProfissionais/ServicosProfissionais"

//user o react-number-formar para os valores


const scheme = z.object({
    nome: z.string(),
    valor: z.string().nullable(),
    tempoEstimado: z.string().nullable(),
    tiposServicosId: z.string().nullable(),
    pernoite: z.coerce.string().nullable(),
    agendavel: z.coerce.string().nullable(),
    precoVariavel: z.coerce.string().nullable(),
    permiteOnline: z.coerce.string().nullable(),
})
const ServicosCadEdit = () => {

    const navigate = useNavigate()
    const { idServico } = useParams();
    const [servico, setServicos] = useState(null)

    const { register, handleSubmit, watch, formState: { errors }, control } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(scheme),
        values: servico
    })
    const registerWithMask = useHookFormMask(register);



    const [keyTab, setKeyTab] = useState('dados')
    const [isPessoaJuridica, setIsPessoaJuridica] = useState(false)
    const watchShowJuridica = watch('tiposPessoasId')
    const [optTiposServico, setOptTiposServico] = useState([])
    const [disableSalvar, setDisableSalvar] = useState(false)
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 9, acoesId: 1 },
        { secoesId: 9, acoesId: 2 },
    ])


    const onSubmit = async (data) => {
        setDisableSalvar(true)
        let DataForm = data
        DataForm.valor = moeda2float(data.valor)
        if (idServico != undefined) {

            const res = await ServicosService.updateById(idServico, DataForm)

            if (res.success) {
                navigate('/admin/configuracoes/servicos')
            } else {
                alert(res.msg)
                setDisableSalvar(false)
            }


        } else {

            const res = await ServicosService.store(DataForm)

            if (res.success) {
                navigate('/admin/configuracoes/servicos')
            } else {
                alert(res.msg)
                setDisableSalvar(false)


            }
        }

    }

    // console.log((idServico))

    useEffect(() => {

        if (idServico != undefined) {
            const fetchData = async () => {
                setIsloading(true);
                const data = await ServicosService.getById(idServico)
                const cli = data.data
                console.log(cli)
                setServicos({
                    ...cli,
                    tiposServicosId: (cli?.tiposServicosId) ? cli?.tiposServicosId.toString() : '',
                    pernoite: cli?.pernoite.toString(),
                    agendavel: cli?.agendavel?.toString(),
                    precoVariavel: cli?.precoVariavel?.toString(),
                    valor: float2moeda(cli?.valor),
                    permiteOnline: cli?.permiteOnline?.toString(),
                })

                setIsloading(false);
            }
            fetchData()
        } else {

            setServicos({
                ...servico,
                pernoite: '0',
                agendavel: '0',
                precoVariavel: '0'
            })

            setIsloading(false);
        }


        /*const fetchTiposServicos = async () => {
            const data = await TiposServicosService.getAll();

            setOptTiposServico(data.data)
        }
        fetchTiposServicos()*/

    }, [])





    console.log(isLoading)
    return (
        <>
            <ConfiguracoesSistemaPrincipal>


                <h3><span className="text-primary">Serviços </span> {(servico?.nome != null) ? '- ' + servico.nome : ''} {(servico?.sobrenome != null) ? servico.sobrenome : ''}</h3>
                <h4 className="text-primary"></h4>
                <hr></hr>


                <div style={{ maxWidth: '800px' }}>


                    {(isLoading) ? <Loading /> : (
                        <>
                            {(
                                (!listPermissoes?.cadastrar && !isLoadingPerm && idServico == null)
                                || (!listPermissoes?.editar && !isLoadingPerm && idServico != null)
                            ) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                                <>
                                    <Tabs
                                        activeKey={keyTab}
                                        onSelect={(k) => setKeyTab(k)}
                                        className="mb-3">
                                        <Tab eventKey="dados" title="Dados" >
                                            <Form>
                                                <Row className="lg-5" >
                                                    <Form.Group as={Col} controlId="formNome" xs={6}>
                                                        <Form.Label>Nome:<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Nome"
                                                            {...register('nome')}
                                                            isInvalid={!!errors?.nome}
                                                        />
                                                        <Form.Control.Feedback type='invalid'>
                                                            {errors?.nome?.message}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formNome" xs={6}>
                                                        <Form.Label>Valor:<span className="text-danger">*</span></Form.Label>
                                                        <Controller
                                                            name="valor"
                                                            control={control}
                                                            render={({ field: { ref, ...rest } }) => (
                                                                <NumericFormat
                                                                    className="form-control"

                                                                    decimalSeparator=","
                                                                    prefix=""
                                                                    decimalScale={2}
                                                                    getInputRef={ref}
                                                                    {...rest}
                                                                />
                                                            )}
                                                        />
                                                    </Form.Group>

                                                </Row>
                                                <Row >
                                                    <Form.Group as={Col} controlId="formTempoEstimado" xs={4}>
                                                        <Form.Label>Tempo Estimado:</Form.Label>
                                                        <Form.Control type="text" placeholder="Tempo em minutos"
                                                            isInvalid={!!errors?.tempoEstimado}
                                                            {...register('tempoEstimado')}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors?.tempoEstimado?.message}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>


                                                    <Form.Group as={Col} md={4} controlId="formTipoServico">
                                                        <Form.Label>Tipo de Serviço:</Form.Label>
                                                        <Form.Select
                                                            {...register('tiposServicosId')}>
                                                            <option value=''>Selecione...</option>
                                                            {tiposServicosUtils()?.map((item) => (
                                                                <option value={item.id.toString()}>{item.nome}</option>
                                                            ))
                                                            }


                                                        </Form.Select>
                                                    </Form.Group>
                                                </Row>
                                                <br></br>
                                                <Row className="mt-10">
                                                    <Form.Group as={Col} xs={12} sm={6} md={4} lg={3}>
                                                        <Form.Label className="mr-10">Pernoite?</Form.Label><br></br>
                                                        <FormCheck type="radio" inline label='Sim' style={{ color: '#ccc' }}
                                                            {...register('pernoite')} value="1" />

                                                        <FormCheck type="radio" inline label='Não' style={{ color: '#ccc' }}
                                                            {...register('pernoite')}
                                                            value="0" />
                                                    </Form.Group>
                                                    <Form.Group as={Col} xs={12} sm={6} md={4} lg={3}>
                                                        <Form.Label className="mr-10">Agendável?</Form.Label><br></br>
                                                        <FormCheck type="radio" inline label='Sim' style={{ color: '#ccc' }}
                                                            {...register('agendavel')} value="1" />

                                                        <FormCheck type="radio" inline label='Não' style={{ color: '#ccc' }}
                                                            {...register('agendavel')}
                                                            value="0" />
                                                    </Form.Group>
                                                    <Form.Group as={Col} xs={12} sm={6} md={3} lg={3}>
                                                        <Form.Label className="mr-10">Permite alteração de preço?</Form.Label><br></br>
                                                        <FormCheck type="radio" inline label='Sim' style={{ color: '#ccc' }}
                                                            {...register('precoVariavel')} value="1" />

                                                        <FormCheck type="radio" inline label='Não' style={{ color: '#ccc' }}
                                                            {...register('precoVariavel')}
                                                            value="0" />
                                                    </Form.Group>
                                                    <Form.Group as={Col} xs={12} sm={6} md={3} lg={3}>
                                                        <Form.Label className="mr-10">Permite agendamento online?</Form.Label><br></br>
                                                        <FormCheck type="radio" inline label='Sim' style={{ color: '#ccc' }}
                                                            {...register('permiteOnline')} value="1" />

                                                        <FormCheck type="radio" inline label='Não' style={{ color: '#ccc' }}
                                                            {...register('permiteOnline')}
                                                            value="0" />
                                                    </Form.Group>
                                                </Row>

                                                <hr></hr>


                                                <div className="text-center ">
                                                    <Button variant="danger" className="mr-15" size="sm" href="/admin/configuracoes/servicos">Cancelar</Button>
                                                    <Button variant="primary" disabled={disableSalvar} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                                        {(disableSalvar) ? <>
                                                            <FontAwesomeIcon icon={["fas", "spinner"]} spin /> Salvando...
                                                        </> : 'Salvar'}</Button>   </div>

                                            </Form>
                                        </Tab>
                                        <Tab eventKey="profissionais" title="Profissionais"  >
                                            {(keyTab == 'profissionais') ? <ServicosProfissionais servico={servico} idServico={idServico} /> : ''}
                                        </Tab>
                                    </Tabs>
                                </>)}
                        </>)}
                </div>

            </ConfiguracoesSistemaPrincipal>

        </>
    )
}
export default ServicosCadEdit